import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";

const AlertPopup = ({
  open,
  onClose,
  title,
  message,
  confirmText,
  cancelText = "CANCEL",
  onConfirm,
  onCancel,
  showCheckCircle = false,
}) => {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: {
          width: "446px",
          minHeight: showCheckCircle ? "250px" : "226px",
          "@media (max-width: 1360px)": {
            minHeight: "250px",
          },
          borderRadius: "12px",
          position: "relative",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 10,
          top: 10,
          color: "#666",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.04)",
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Dialog Content */}
      <DialogContent
        sx={{
          textAlign: "center",
          pt: showCheckCircle ? 4 : 7,
          pb: 0,
          px: 3,
        }}
      >
        {/* CheckCircle Icon */}
        {showCheckCircle && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Box
              sx={{
                width: "56px",
                height: "56px",
                backgroundColor: "#f5f5f5",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircleOutlinedIcon
                sx={{
                  width: "32px",
                  height: "32px",
                  color: "#4CAF50",
                }}
              />
            </Box>
          </Box>
        )}

        <Typography
          variant="h5"
          sx={{
            fontWeight: "600",
            color: "#333",
            mb: 1,
            fontSize: "16px",
            pt: !message && !showCheckCircle ? 2 : 0,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            fontSize: "14px",
            lineHeight: 1.5,
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          "@media (max-width: 400px)": {
            gap: 1,
          },
          pb: 6,
          px: 3,
        }}
      >
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#EF5658",
            color: "white",
            borderRadius: "4px",
            //  px: 3,
            py: 1.5,
            height: "36px",
            fontSize: "14px",
            fontWeight: "meduim",
            textTransform: "uppercase",
            minWidth: "92px",
            "&:hover": {
              backgroundColor: "#D33338",
            },
          }}
        >
          {confirmText}
        </Button>
        {cancelText &&
        <Button
          onClick={handleCancel}
          variant="outlined"
          sx={{
            borderColor: "#666",
            color: "#666",
            borderRadius: "4px",
            px: 3,
            py: 1.5,
            fontSize: "14px",
            fontWeight: "meduim",
            height: "36px",
            textTransform: "uppercase",
            minWidth: "92px",
            "&:hover": {
              borderColor: "#666",
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
        >
          {cancelText}
        </Button>}
      </DialogActions>
    </Dialog>
  );
};

export default AlertPopup;
